/**
 * Craftpedia Intelligence - Pillars & Filter Interaction
 * Compliant with AGENTS.md JavaScript guidelines
 */
(function () {
  'use strict';

  function initIntelPillars() {
    var section = document.querySelector('[data-intel-section]');
    if (!section) return;

    function getCheckedValues(type) {
      var inputs = section.querySelectorAll('[data-intel-checkbox="' + type + '"]:checked');
      var vals = [];
      inputs.forEach(function (inp) { vals.push(inp.value); });
      return vals;
    }

    var state = {
      activeTab: 'all',
      selectedCrafts: getCheckedValues('craft'),
      selectedMaterials: getCheckedValues('material'),
      visibleCount: 9,
      batchSize: 6
    };

    // DOM Elements Cache
    var elements = {
      dropdownGroups: section.querySelectorAll('[data-intel-dropdown]'),
      triggers: section.querySelectorAll('[data-intel-trigger]'),
      tabsContainer: section.querySelector('[data-intel-tabs-container]') || section.querySelector('.cp-intel-tabs-container'),
      tabButtons: section.querySelectorAll('[data-intel-tab]'),
      cards: section.querySelectorAll('[data-intel-card]'),
      chipsContainer: section.querySelector('[data-intel-chips]'),
      filterDivider: section.querySelector('[data-intel-filter-divider]'),
      clearAllBtn: section.querySelector('[data-intel-clear-all]'),
      showMoreBtn: section.querySelector('[data-intel-show-more]'),
      searchInputs: section.querySelectorAll('[data-intel-search]'),
      applyButtons: section.querySelectorAll('[data-intel-apply]'),
      clearDropdownButtons: section.querySelectorAll('[data-intel-dropdown-clear]')
    };

    // Auto-hide tabs that have no matching cards on this page
    elements.tabButtons.forEach(function (btn) {
      var tabKey = (btn.getAttribute('data-intel-tab') || '').toLowerCase();
      if (tabKey === 'all') return;
      var hasMatchingCards = false;
      elements.cards.forEach(function (card) {
        var cardCategory = (card.getAttribute('data-intel-category') || '').toLowerCase();
        if (cardCategory.indexOf(tabKey) !== -1) {
          hasMatchingCards = true;
        }
      });
      if (!hasMatchingCards) {
        btn.style.display = 'none';
      } else {
        btn.style.display = '';
      }
    });

    // Toggle Dropdown
    function toggleDropdown(group) {
      if (!group) return;
      var isOpen = group.classList.contains('is-open');
      closeAllDropdowns();
      if (!isOpen) {
        group.classList.add('is-open');
      }
    }

    function closeAllDropdowns() {
      elements.dropdownGroups.forEach(function (group) {
        group.classList.remove('is-open');
      });
    }

    // Filter Cards Logic
    function matchesFilters(card) {
      if (!card) return false;
      var cardTab = (card.getAttribute('data-intel-category') || '').toLowerCase();
      var cardCraft = (card.getAttribute('data-intel-craft') || '').toLowerCase();
      var cardMaterial = (card.getAttribute('data-intel-material') || '').toLowerCase();

      // Check tab filter
      if (state.activeTab !== 'all' && cardTab.indexOf(state.activeTab.toLowerCase()) === -1) {
        return false;
      }

      var hasCraftFilter = state.selectedCrafts.length > 0;
      var hasMaterialFilter = state.selectedMaterials.length > 0;

      // If no dropdown filters active, card matches the tab
      if (!hasCraftFilter && !hasMaterialFilter) {
        return true;
      }

      var matchesCraft = false;
      if (hasCraftFilter) {
        var craftSegments = cardCraft.split(',').map(function (s) { return s.trim(); });
        matchesCraft = state.selectedCrafts.some(function (craft) {
          return craftSegments.indexOf(craft.toLowerCase()) !== -1;
        });
      }

      var matchesMaterial = false;
      if (hasMaterialFilter) {
        var matSegments = cardMaterial.split(',').map(function (s) { return s.trim(); });
        matchesMaterial = state.selectedMaterials.some(function (mat) {
          return matSegments.indexOf(mat.toLowerCase()) !== -1;
        });
      }

      // If both filters are active, show cards matching either selected craft OR selected material
      if (hasCraftFilter && hasMaterialFilter) {
        return matchesCraft || matchesMaterial;
      }

      if (hasCraftFilter) {
        return matchesCraft;
      }

      if (hasMaterialFilter) {
        return matchesMaterial;
      }

      return true;
    }

    // Update Option Counts in Dropdowns
    function updateOptionCounts() {
      if (!elements.cards || elements.cards.length === 0) return;

      section.querySelectorAll('[data-intel-checkbox]').forEach(function (cb) {
        var val = (cb.value || '').trim().toLowerCase();
        var type = cb.getAttribute('data-intel-checkbox');
        var count = 0;

        elements.cards.forEach(function (card) {
          var attr = type === 'craft'
            ? (card.getAttribute('data-intel-craft') || '')
            : (card.getAttribute('data-intel-material') || '');
          var segments = attr.toLowerCase().split(',').map(function (s) { return s.trim(); });
          if (segments.indexOf(val) !== -1) {
            count++;
          }
        });

        var label = cb.closest('.cp-intel-option-label');
        var countSpan = label ? label.querySelector('.cp-intel-option-count') : null;
        if (countSpan) {
          countSpan.textContent = count;
        }

        var item = cb.closest('.cp-intel-option-item');
        if (item) {
          item.style.display = count === 0 ? 'none' : 'flex';
        }
      });
    }

    // Render Cards & Active State
    function render() {
      var matchingCount = 0;

      elements.cards.forEach(function (card) {
        var isMatch = matchesFilters(card);
        if (isMatch) {
          matchingCount++;
          if (matchingCount <= state.visibleCount) {
            card.style.display = 'flex';
          } else {
            card.style.display = 'none';
          }
        } else {
          card.style.display = 'none';
        }
      });

      // Update Show More button visibility
      if (elements.showMoreBtn) {
        if (matchingCount > state.visibleCount) {
          elements.showMoreBtn.style.display = 'inline-flex';
        } else {
          elements.showMoreBtn.style.display = 'none';
        }
      }

      renderChips();
      updateBadges();
      updateOptionCounts();
    }

    // Update Filter Badges
    function updateBadges() {
      var craftBadge = section.querySelector('[data-intel-craft-badge]');
      var materialBadge = section.querySelector('[data-intel-material-badge]');
      var craftTrigger = section.querySelector('[data-intel-dropdown="craft"] [data-intel-trigger]');
      var materialTrigger = section.querySelector('[data-intel-dropdown="material"] [data-intel-trigger]');

      if (craftBadge) {
        craftBadge.textContent = state.selectedCrafts.length;
        craftBadge.style.display = state.selectedCrafts.length > 0 ? 'inline-flex' : 'none';
      }
      if (craftTrigger) {
        if (state.selectedCrafts.length > 0) {
          craftTrigger.classList.add('is-active');
        } else {
          craftTrigger.classList.remove('is-active');
        }
      }

      if (materialBadge) {
        materialBadge.textContent = state.selectedMaterials.length;
        materialBadge.style.display = state.selectedMaterials.length > 0 ? 'inline-flex' : 'none';
      }
      if (materialTrigger) {
        if (state.selectedMaterials.length > 0) {
          materialTrigger.classList.add('is-active');
        } else {
          materialTrigger.classList.remove('is-active');
        }
      }
    }

    // Render Filter Chips
    function renderChips() {
      if (!elements.chipsContainer) return;

      var allSelected = [];
      state.selectedCrafts.forEach(function (c) {
        allSelected.push({ type: 'craft', value: c });
      });
      state.selectedMaterials.forEach(function (m) {
        allSelected.push({ type: 'material', value: m });
      });

      // Remove only previous chip elements, leaving clear-all button
      elements.chipsContainer.querySelectorAll('.cp-intel-chip').forEach(function (el) {
        el.remove();
      });

      if (allSelected.length === 0) {
        if (elements.clearAllBtn) elements.clearAllBtn.style.display = 'none';
        if (elements.filterDivider) elements.filterDivider.style.display = 'none';
        return;
      }

      if (elements.filterDivider) elements.filterDivider.style.display = 'block';

      allSelected.forEach(function (item) {
        var chip = document.createElement('div');
        chip.className = 'cp-intel-chip';
        chip.innerHTML = '<span>' + item.value + '</span>' +
          '<button type="button" class="cp-intel-chip-remove" data-intel-chip-remove data-type="' + item.type + '" data-value="' + item.value + '" aria-label="Remove ' + item.value + '">✕</button>';
        if (elements.clearAllBtn && elements.clearAllBtn.parentNode === elements.chipsContainer) {
          elements.chipsContainer.insertBefore(chip, elements.clearAllBtn);
        } else {
          elements.chipsContainer.appendChild(chip);
        }
      });

      if (elements.clearAllBtn) {
        elements.clearAllBtn.style.display = 'inline-flex';
        if (elements.clearAllBtn.parentNode !== elements.chipsContainer) {
          elements.chipsContainer.appendChild(elements.clearAllBtn);
        }
      }
    }

    // Event Handlers
    elements.triggers.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var group = btn.closest('[data-intel-dropdown]');
        toggleDropdown(group);
      });
    });

    document.addEventListener('click', function (e) {
      if (!section.contains(e.target)) {
        closeAllDropdowns();
      }
    });

    // Tab Scrolling (Trackpad, Mouse Wheel, Grab-to-Drag)
    function initTabsScrolling(container) {
      if (!container) return;

      var isMouseDown = false;
      var startPageX = 0;
      var startScrollLeft = 0;
      var isDragging = false;

      container.addEventListener('wheel', function (event) {
        if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) {
          var canScrollLeft = container.scrollLeft > 0 && event.deltaY < 0;
          var canScrollRight = (container.scrollLeft + container.clientWidth < container.scrollWidth - 1) && event.deltaY > 0;

          if (canScrollLeft || canScrollRight) {
            event.preventDefault();
            container.scrollLeft += event.deltaY;
          }
        }
      }, { passive: false });

      container.addEventListener('mousedown', function (event) {
        if (event.button !== 0) return;
        isMouseDown = true;
        isDragging = false;
        startPageX = event.pageX - container.offsetLeft;
        startScrollLeft = container.scrollLeft;
      });

      window.addEventListener('mousemove', function (event) {
        if (!isMouseDown) return;
        var currentPageX = event.pageX - container.offsetLeft;
        var distance = currentPageX - startPageX;

        if (Math.abs(distance) > 4) {
          isDragging = true;
          container.classList.add('is-dragging');
        }

        if (isDragging) {
          container.scrollLeft = startScrollLeft - distance;
        }
      });

      window.addEventListener('mouseup', function () {
        if (isMouseDown) {
          isMouseDown = false;
          container.classList.remove('is-dragging');
        }
      });

      container.addEventListener('click', function (event) {
        if (isDragging) {
          event.preventDefault();
          event.stopPropagation();
          isDragging = false;
        }
      }, true);
    }

    if (elements.tabsContainer) {
      initTabsScrolling(elements.tabsContainer);
    }

    // Tab buttons
    elements.tabButtons.forEach(function (tab) {
      tab.addEventListener('click', function () {
        elements.tabButtons.forEach(function (t) { t.classList.remove('is-active'); });
        tab.classList.add('is-active');
        state.activeTab = tab.getAttribute('data-intel-tab') || 'all';
        state.visibleCount = 9;

        if (typeof tab.scrollIntoView === 'function') {
          tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }

        render();
      });
    });

    // Remove Chip Click Delegation
    if (elements.chipsContainer) {
      elements.chipsContainer.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-intel-chip-remove]');
        if (!btn) return;
        var type = btn.getAttribute('data-type');
        var val = btn.getAttribute('data-value');

        if (type === 'craft') {
          state.selectedCrafts = state.selectedCrafts.filter(function (c) { return c !== val; });
          var cb = section.querySelector('[data-intel-checkbox="craft"][value="' + val + '"]');
          if (cb) cb.checked = false;
        } else if (type === 'material') {
          state.selectedMaterials = state.selectedMaterials.filter(function (m) { return m !== val; });
          var cbMat = section.querySelector('[data-intel-checkbox="material"][value="' + val + '"]');
          if (cbMat) cbMat.checked = false;
        }

        render();
      });
    }

    // Clear All Click
    if (elements.clearAllBtn) {
      elements.clearAllBtn.addEventListener('click', function () {
        state.selectedCrafts = [];
        state.selectedMaterials = [];
        section.querySelectorAll('[data-intel-checkbox]').forEach(function (cb) {
          cb.checked = false;
        });
        render();
      });
    }

    // Show More Click
    if (elements.showMoreBtn) {
      elements.showMoreBtn.addEventListener('click', function () {
        state.visibleCount += state.batchSize;
        render();
      });
    }

    // Search inside dropdown
    elements.searchInputs.forEach(function (input) {
      input.addEventListener('input', function () {
        var query = (input.value || '').trim().toLowerCase();
        var group = input.closest('[data-intel-dropdown]');
        var type = group.getAttribute('data-intel-dropdown');
        var optionsList = group.querySelector('.cp-intel-options-list');
        var list = group.querySelectorAll('.cp-intel-option-item');
        var visibleCount = 0;

        list.forEach(function (item) {
          var isMatch = (item.textContent || '').toLowerCase().indexOf(query) !== -1;
          item.style.display = isMatch ? 'flex' : 'none';
          if (isMatch) visibleCount++;
        });

        // Show/hide "no results" empty state
        var noResults = optionsList ? optionsList.querySelector('.cp-intel-no-results') : null;
        if (visibleCount === 0) {
          if (!noResults && optionsList) {
            noResults = document.createElement('li');
            noResults.className = 'cp-intel-no-results';
            noResults.textContent = type === 'material' ? 'No materials found' : 'No crafts found';
            optionsList.appendChild(noResults);
          }
        } else if (noResults) {
          noResults.remove();
        }
      });
    });

    // Apply Filter Buttons inside dropdowns
    elements.applyButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('[data-intel-dropdown]');
        var type = group.getAttribute('data-intel-dropdown');
        var checkboxes = group.querySelectorAll('[data-intel-checkbox]:checked');
        var selected = Array.from(checkboxes).map(function (cb) { return cb.value; });

        if (type === 'craft') {
          state.selectedCrafts = selected;
        } else if (type === 'material') {
          state.selectedMaterials = selected;
        }

        closeAllDropdowns();
        state.visibleCount = 9;
        render();
      });
    });

    // Clear single dropdown
    elements.clearDropdownButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var group = btn.closest('[data-intel-dropdown]');
        var type = group.getAttribute('data-intel-dropdown');
        group.querySelectorAll('[data-intel-checkbox]').forEach(function (cb) {
          cb.checked = false;
        });

        // Also empty the search box; re-running its handler restores the full option list.
        var searchInput = group.querySelector('[data-intel-search]');
        if (searchInput && searchInput.value !== '') {
          searchInput.value = '';
          searchInput.dispatchEvent(new Event('input', { bubbles: true }));
        }

        if (type === 'craft') {
          state.selectedCrafts = [];
        } else if (type === 'material') {
          state.selectedMaterials = [];
        }

        state.visibleCount = 9;
        render();
      });
    });

    // Initial render
    render();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initIntelPillars);
  } else {
    initIntelPillars();
  }
})();
